module.exports = __webpack_public_path__ + "static/media/menu7.e3e9dc2e.jpg";